module.exports = __webpack_public_path__ + "img/logo.0f9bcc12.png";